/**
 * Created by adam.clarke on 10/11/2016.
 */
//edit-rides-rides


admin.registerLoad(function (prefix) {

    $(prefix + ".edit-rides-rides .identifier_route select").off("change");
    $(prefix + ".edit-rides-rides .identifier_route select").on("change", function () {
        var $this = $(this);

        var url = "/data/route/" + $this.val();

        $.ajax({
            url: url
        }).done(function (data) {
            var route = data.data;
            $('#data-distance_in_miles').val(parseFloat(Math.round(parseFloat(route.distance) * 10) / 10));
            $('#data-start_postcode').val(route.start_postcode);
            $('#data-starting_point').val(route.start_description);
            $('#data-location').val(route.location);
            $('#data-location').trigger("chosen:updated");

            $('#data-override_cycle_types').prop("checked", true);
            $('.identifier_cycle_types').show();

            // setup the selected cycle types for the current route
            $('#data-cycle_types option:selected').removeAttr("selected");
            for (var i in route.cycle_types) {
                var cycle_type = route.cycle_types[i];
                $('#data-cycle_types option').each(function () {
                    if ($(this).attr("value") == cycle_type.id.toString()) {
                        $(this).prop("selected", true);
                    }
                })
            }
            $('#data-cycle_types option:selected').trigger("chosen:updated");
        }).error(function () {

        });
    });
});